import { Button, CircularProgress, Grid, SvgIcon } from '@mui/material';
import { ClockCheck, Save01 } from '../../../assets';
import { useContext } from 'react';
import { ScheduleCreateContext, ScheduleCreateValues } from '../contexts/ScheduleCreateContext';
import LoadingWheel from '../../../components/ui/LoadingWheel';
import PageTitle from '../../../components/shared/PageTitle';
import BackButton from '../../../components/shared/actions/BackButton';
import { UserContext } from '../../../components/shared/useUser';

const ScheduleCreateTop = () => {
  const { t,
    isLoading,
    schedules,
    handleLeaveClick,
    submitStock,
    isCreating,
    generateStock,
    name,
    isGenerating,
    hasRightToEdit } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  const { hasPermissionTo } = useContext(UserContext);


  return (
    <Grid container>
      <Grid item
        xs={12}>
        <BackButton
          handleClick={handleLeaveClick}
          title={t('exit')}
          isLink={false}
        />
      </Grid>
      <Grid
        item
        container
        xs={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item
          xs={12}>
          <PageTitle>{isCreating ? t('title') : t('editTitle')}</PageTitle>
        </Grid>
        {!isLoading &&
          <Grid item
            xs={12}
            sx={{ display: 'flex', justifyContent: 'flex-end', alignContent: 'flex-end' }}>
            {hasPermissionTo(['GenerateScheduleAdmin']) && !isCreating && <Button size='lg'
              disabled={!name || (schedules.length === 0) || !hasRightToEdit || isGenerating}
              startIcon={isGenerating ? <CircularProgress size={20}
                sx={{ ml: '-4px', mr: '4px' }} /> : <SvgIcon><ClockCheck /></SvgIcon>}
              onClick={generateStock}>
              {t('generateSchedules')}
            </Button>}
            <Button size='lg'
              sx={{ ml: 4 }}
              disabled={!name || (schedules.length === 0) || !hasRightToEdit}
              onClick={submitStock}>
              {isCreating ? <><Save01 />{t('create')}</> : <><Save01 />{t('save')}</>}
            </Button>
          </Grid>}
      </Grid>
      {isLoading && <Grid item
        xs={12}>
        <LoadingWheel />
      </Grid>}
    </Grid>
  );
};

export default ScheduleCreateTop;